(function () {
  function setupCarousel(root) {
    var track = root.querySelector('[data-carousel-track]');
    if (!track) return;

    var originals = Array.prototype.slice.call(track.children);
    if (!originals.length) return;

    originals.forEach(function (el, i) {
      el.dataset.index = i;
    });

    var cloneCount = Math.min(2, originals.length);
    var headClones = originals.slice(0, cloneCount).map(function (el) {
      var clone = el.cloneNode(true);
      clone.dataset.clone = 'true';
      return clone;
    });
    var tailClones = originals.slice(-cloneCount).map(function (el) {
      var clone = el.cloneNode(true);
      clone.dataset.clone = 'true';
      return clone;
    });

    tailClones.forEach(function (clone) {
      track.insertBefore(clone, track.firstChild);
    });
    headClones.forEach(function (clone) {
      track.appendChild(clone);
    });

    var byIndex = {};
    originals.forEach(function (el) {
      byIndex[el.dataset.index] = el;
    });

    var allSlides = Array.prototype.slice.call(track.children);

    var reduceMotion =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function centerOn(el, instant) {
      var target = el.offsetLeft + el.offsetWidth / 2 - track.clientWidth / 2;
      track.scrollTo({ left: target, behavior: instant || reduceMotion ? 'auto' : 'smooth' });
    }

    function closestSlide() {
      var center = track.scrollLeft + track.clientWidth / 2;
      var best = null;
      var bestDist = Infinity;
      allSlides.forEach(function (slide) {
        var slideCenter = slide.offsetLeft + slide.offsetWidth / 2;
        var dist = Math.abs(slideCenter - center);
        if (dist < bestDist) {
          bestDist = dist;
          best = slide;
        }
      });
      return best;
    }

    function markActive(slide) {
      allSlides.forEach(function (s) {
        s.classList.toggle('is-active', s === slide);
      });
    }

    function settle() {
      var active = closestSlide();
      if (active && active.dataset.clone === 'true') {
        var real = byIndex[active.dataset.index];
        if (real) {
          centerOn(real, true);
          markActive(real);
          return;
        }
      }
      markActive(active);
    }

    var scrollTimer;
    track.addEventListener(
      'scroll',
      function () {
        markActive(closestSlide());
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(settle, 120);
      },
      { passive: true }
    );

    function step(direction) {
      var active = closestSlide();
      if (!active) return;
      var target = direction === 1 ? active.nextElementSibling : active.previousElementSibling;
      if (target) centerOn(target, false);
    }

    var prevButton = root.querySelector('[data-carousel-prev]');
    var nextButton = root.querySelector('[data-carousel-next]');
    if (prevButton) prevButton.addEventListener('click', function () { step(-1); });
    if (nextButton) nextButton.addEventListener('click', function () { step(1); });

    centerOn(originals[0], true);
    markActive(originals[0]);

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        var active = closestSlide();
        if (active) centerOn(active, true);
      }, 150);
    });
  }

  function init() {
    document.querySelectorAll('[data-carousel]').forEach(setupCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
